import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {PaperAirplaneIcon} from '@heroicons/react/24/outline';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import {DialogManager} from '@/dialogs_new/DialogManager';
import useIsEventShareable from '@/features/share-event/hooks/useIsEventShareable';

EventShareButton.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      published: PropTypes.bool
    })
  }).isRequired
};

export default function EventShareButton(props) {
  const {event} = props;
  const {t} = useTranslation();
  const launch = useDialogLauncher();
  const isShareable = useIsEventShareable(event);

  if (!isShareable) {
    return null;
  }

  return (
    <button
      type="button"
      className="flex items-center gap-1 text-cs-orange-500 hover:opacity-75"
      onClick={() => launch(DialogManager.EventShare.Config(event.id, 'manage'))}
    >
      <PaperAirplaneIcon className="h-5 w-5 -rotate-[30deg]" aria-hidden="true"/>
      <span className="text-sm font-semibold">{t('event_share.cta')}</span>
    </button>
  );
}
